import SubCollectionEntityService from '@/services/SubCollectionEntiyService'
import { Proposal, proposalConverter } from '@/models/proposal'

export default class ChangeOrderService extends SubCollectionEntityService<Proposal> { 
  constructor(parentDocument: string) {
    super({ parentDocument, subCollectionName: 'changeOrders', converter: proposalConverter })
  }
}